import 'intersection-observer'
import * as React from "react"
import { IOWidget, Updater, fromJSX } from "widgets-for-react"
import { Link } from "../../../../cms/blocks/types.gen"
import { link } from "../../../../cms/blocks/utils.gen"
import { CMSState } from '../../../drupalPage/state'

export type quoteBlockProps = {
  blockIndex: number
  quote: string
  person: string
  function: string
  background: "grey" | "white" | "orange"
  primaryButton?: Link
  secondaryButton?: Link
}

export type QuoteBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function quoteBlock(
  props: quoteBlockProps,
  options?: { style: QuoteBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
    return (s: CMSState) => fromJSX(
      _ => {
        return (
          // <div className={`block block--quote${props.background == 'grey' ? " block--color" : props.background == 'orange' ? " block--orange" : ""}`}>
          <div className={`block block--quote`}>
            <div className="block__inner container container--s grid--block">
              <div className='block__content'>
                <blockquote className='block__quote title--m'>
                  <p>{props.quote}</p>
                </blockquote>

                {props.person && (
                  <figcaption className='block__author'>
                    <span className='block__name'>{props.person}</span>
                    {props.function && <span className='block__function'>{props.function}</span>}
                  </figcaption>
                )}
                
                {props.primaryButton && <footer className='block__footer'>
                  <div className={"block__clickable"}> 
                    {link(props.primaryButton, {classname: "button button--primary"}, props.primaryButton.title,
                      () => {
                        window.dataLayer.push({
                          event: 'event.refresco',
                          category: 'QuoteBlock',
                          action: props.primaryButton.title,
                          label: window.location.pathname,
                        })
                      })}
                  </div>
                  {props.secondaryButton && 
                    <div className={"block__clickable"}> 
                      {link(props.secondaryButton, {classname: "link link--secondary"}, props.secondaryButton.title,
                        () => {
                          window.dataLayer.push({
                            event: 'event.refresco',
                            category: 'QuoteBlock',
                            action: props.primaryButton.title,
                            label: window.location.pathname,
                          })
                        })}
                    </div>
                  }
                </footer>}
              </div>
            </div>
          </div>
        )
      },
    )
}
